import { render, staticRenderFns } from "./FormatListNumbers.vue?vue&type=template&id=2921c277&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormatListNumbers.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/FormatListNumbers.vue
// module id = 2308
// module chunks = 1